/**
 * Validates a referral code
 * @param {string} code - The referral code to validate
 * @returns {boolean} - True if valid, false otherwise
 */
export const validateReferralCode = (code) => {
  return code.trim() === 'Bright';
};

/**
 * Gets the appropriate error message for referral code validation
 * @param {string} code - The referral code that was validated
 * @returns {string} - Error message or empty string if valid
 */
export const getReferralCodeError = (code) => {
  if (!code || code.trim() === '') {
    return 'Referral code is required';
  }
  if (!validateReferralCode(code)) {
    return 'Invalid referral code. Please check your code and try again.';
  }
  return '';
};

/**
 * Gets user-friendly error messages for Firebase Auth error codes
 * @param {string} errorCode - The Firebase Auth error code
 * @returns {string} - User-friendly error message
 */
export const getFirebaseErrorMessage = (errorCode) => {
  switch (errorCode) {
    case 'auth/invalid-credential':
    case 'auth/invalid-login-credentials':
      return 'Invalid email or password. Please check your credentials and try again.';
    case 'auth/user-not-found':
      return 'No account found with this email address.';
    case 'auth/wrong-password':
      return 'Incorrect password. Please try again.';
    case 'auth/invalid-email':
      return 'Please enter a valid email address.';
    case 'auth/user-disabled':
      return 'This account has been disabled. Please contact support.';
    case 'auth/too-many-requests':
      return 'Too many failed attempts. Please try again later.';
    case 'auth/email-already-in-use':
      return 'An account with this email already exists.';
    case 'auth/weak-password':
      return 'Password is too weak. Please choose a stronger password.';
    case 'auth/popup-closed-by-user':
      return 'Sign-in cancelled. Please try again.';
    case 'auth/popup-blocked':
      return 'Sign-in popup was blocked. Please allow popups for this site.';
    case 'auth/operation-not-allowed':
      return 'This sign-in method is not enabled.';
    case 'auth/network-request-failed':
      return 'Network error. Please check your connection and try again.';
    case 'auth/expired-action-code':
      return 'This link has expired. Please request a new one.';
    case 'auth/invalid-action-code':
      return 'This link is invalid. Please request a new one.';
    default:
      return 'An error occurred. Please try again.';
  }
};